import { IconHintFilled } from '@holbonkit/icons'
import {
    Button,
    Popover,
    PopoverContent,
    PopoverDescription,
    PopoverHeader,
    PopoverTrigger,
} from '@holbonkit/ui'

import styles from './popover.module.scss'

type TPopoverUpcomingProps = {
    isPopoverOpen: boolean
    setIsPopoverOpen: (value: boolean) => void
}

export const PopoverUpcoming = ({ isPopoverOpen, setIsPopoverOpen }: TPopoverUpcomingProps) => {
    return (
        <Popover open={isPopoverOpen} onOpenChange={setIsPopoverOpen}>
            <PopoverTrigger
                render={
                    <button
                        aria-label='Подробнее о зачислении'
                        className={styles['trigger']}
                        data-test-id='withdrawal-smz-hint'
                        type='button'
                    >
                        <IconHintFilled color='var(--text-and-icon-secondary)' size={16} />
                    </button>
                }
            />
            <PopoverContent align='start' alignOffset={-16} side='bottom'>
                <PopoverHeader>
                    <PopoverDescription>
                        Это деньги за последние заказы. Их можно будет вывести после проверки
                        заказов через 4 часа
                    </PopoverDescription>
                </PopoverHeader>
                <Button size='sm' variant='secondary' onClick={() => setIsPopoverOpen(false)}>
                    Хорошо
                </Button>
            </PopoverContent>
        </Popover>
    )
}

type TPopoverWithdrawalProps = {
    isPopoverOpen: boolean
    setIsPopoverOpen: (value: boolean) => void
}

export const PopoverWithdrawal = ({ isPopoverOpen, setIsPopoverOpen }: TPopoverWithdrawalProps) => {
    return (
        <Popover open={isPopoverOpen} onOpenChange={setIsPopoverOpen}>
            <PopoverTrigger nativeButton={false} render={<span className={styles['anchor']} />} />
            <PopoverContent align='center' side='bottom'>
                <PopoverHeader>
                    <PopoverDescription>
                        Выводите сразу или позже — деньги могут копиться
                    </PopoverDescription>
                </PopoverHeader>
            </PopoverContent>
        </Popover>
    )
}

type TPopoverDeductedProps = {
    isPopoverOpen: boolean
    setIsPopoverOpen: (value: boolean) => void
}

export const PopoverDeducted = ({ isPopoverOpen, setIsPopoverOpen }: TPopoverDeductedProps) => {
    return (
        <Popover open={isPopoverOpen} onOpenChange={setIsPopoverOpen}>
            <PopoverTrigger nativeButton={false} render={<span className={styles['anchor']} />} />
            <PopoverContent align='center' side='bottom'>
                <PopoverHeader>
                    <PopoverDescription>
                        Это сумма
                        <br />
                        комиссии Drivee
                        <br />с НДС за текущий
                        <br />
                        месяц
                    </PopoverDescription>
                </PopoverHeader>
            </PopoverContent>
        </Popover>
    )
}
